module.exports = __webpack_public_path__ + "static/media/aquapark-opti.d774c621.mp4";